import { Tool, g } from '@hcie/core';
import { undoImage, redoImage, clearSelected } from '../event-dispatcher';
import { selectTool } from '../event-dispatcher';
import { deselect, invertSelection, selectAll, copySelection, pasteSelection, cutSelection } from '@hcie/tools';
import { renderLayers } from '../layers';

export class KeyboardHandler {
    static handleKeyDown(e: KeyboardEvent) {
        // Prevent shortcuts when typing in inputs
        if (['INPUT', 'TEXTAREA', 'SELECT'].includes((e.target as HTMLElement).tagName)) return;

        const ctrl = e.ctrlKey || e.metaKey;
        const shift = e.shiftKey;

        // Undo / Redo
        if (ctrl && e.key.toLowerCase() === 'z') {
            e.preventDefault();
            if (shift) redoImage(); else undoImage();
            return;
        }
        if (ctrl && e.key.toLowerCase() === 'y') {
            e.preventDefault();
            redoImage();
            return;
        }

        // Selection Shortcuts
        if (ctrl && e.key.toLowerCase() === 'a') {
            e.preventDefault();
            selectAll();
            return;
        }
        if (ctrl && e.key.toLowerCase() === 'd') {
            e.preventDefault();
            deselect();
            return;
        }
        if (ctrl && shift && e.key.toLowerCase() === 'i') {
            e.preventDefault();
            invertSelection();
            return;
        }

        // Clipboard
        if (ctrl && e.key.toLowerCase() === 'c') {
            e.preventDefault();
            copySelection();
            return;
        }
        if (ctrl && e.key.toLowerCase() === 'v') {
            e.preventDefault();
            pasteSelection();
            return;
        }
        if (ctrl && e.key.toLowerCase() === 'x') {
            e.preventDefault();
            cutSelection();
            return;
        }

        // Tool Switches
        const toolMap: Record<string, Tool> = {
            'b': Tool.Brush,
            'p': Tool.Pen,
            'e': Tool.Eraser,
            'g': Tool.Flood_Fill,
            't': Tool.Text,
            'm': Tool.MoveSelection,
            'v': Tool.MoveContent,
            'l': Tool.Lasso,
            'r': Tool.RectSelect,
            'o': Tool.EllipseSelect,
            'c': Tool.CircleSelect
        };

        const key = e.key.toLowerCase();
        if (toolMap[key] && !ctrl) {
            selectTool(toolMap[key]);
            return;
        }

        // Zoom
        if (ctrl && (e.key === '=' || e.key === '+')) {
            e.preventDefault();
            g.zoom *= g.zoomFactor;
            renderLayers();
            return;
        }
        if (ctrl && e.key === '-') {
            e.preventDefault();
            g.zoom /= g.zoomFactor;
            renderLayers();
            return;
        }
        if (ctrl && e.key === '0') {
            e.preventDefault();
            g.zoom = 1;
            renderLayers();
            return;
        }

        // Commit / Cancel (Ghost Mode)
        if (e.key === 'Enter') {
            if (typeof (window as any).commitDrawing === 'function') {
                (window as any).commitDrawing();
                e.preventDefault();
            }
            return;
        }
        if (e.key === 'Escape') {
            if (typeof (window as any).cancelDrawing === 'function') {
                (window as any).cancelDrawing();
                e.preventDefault();
            }
            return;
        }
    }
}
